module.exports = __webpack_public_path__ + "b19d23a25ba71ffc2154d0cd5eeca24e.png";